/* eslint-disable prefer-destructuring */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTheme } from '@material-ui/core/styles';
import { useMediaQuery } from '@material-ui/core';
import {
  isPurefloDomain,
  isSelfServeDomain,
  isAcquisitionDomain,
} from 'utils/domainHelper';
import { Container } from 'components/Ui';
import Logo from 'components/Logos/Logo';
import Content from './Content';
import LearnMore from './LearnMore';
import Copyright from './Copyright';

const Footer = (
  {
    isCostcoWater,
    document: {
      fields: { learnMore, contact, content, background, copyright },
    },
  },
  { stylesTheme },
) => {
  const styles = require(`./styles/${stylesTheme}.scss`);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.down('md'));
  const isPureflo = isPurefloDomain();
  const isMobileOrTablet = isMobile || isTablet;

  const isSelfServe = isSelfServeDomain();
  const isAcquisition = isAcquisitionDomain();

  return (
    <footer
      className={classnames(styles.footer, {
        [styles.selfServe]: isSelfServe,
      })}
      style={{
        backgroundImage:
          background && (!(isMobile || isTablet) || !isPureflo)
            ? `url(${background.fields.file.url}?fm=webp)`
            : null,
      }}
    >
      {(isMobile || isTablet) && isPureflo && (
        <div
          className={styles.waveBorder}
          style={{
            backgroundImage: background
              ? `url(${background.fields.file.url}?fm=webp)`
              : null,
          }}
        />
      )}
      <Container value="Footer" className={styles.container}>
        <div
          className={classnames(styles.logo, {
            [styles.costcoLogo]: isCostcoWater,
          })}
        >
          <Logo />
        </div>
        <div
          className={classnames(
            { [styles.footerBlocks]: !isSelfServe },
            { [styles.costcoWater]: isCostcoWater },
          )}
        >
          {isAcquisition && <Content fields={content} />}
        </div>
        {!isMobileOrTablet && (
          <Copyright isCostcoWater={isCostcoWater} fields={copyright} />
        )}
        {isCostcoWater && <LearnMore isMobile={isMobile} fields={learnMore} />}
        {isMobileOrTablet && (
          <Copyright isCostcoWater={isCostcoWater} fields={copyright} />
        )}
      </Container>
    </footer>
  );
};

Footer.propTypes = {
  document: PropTypes.object,
  isCostcoWater: PropTypes.bool,
};

Footer.contextTypes = {
  stylesTheme: PropTypes.string,
};

export default Footer;
